export const remoteLessonSimpleDTOFields = {
    id: 'id',
    name: 'name',
    date: 'date',
    creatorFirstName: 'creatorFirstName',
    creatorLastName: 'creatorLastName',
    homeworkDeadline: 'homeworkDeadline',
    readByCount: 'readByCount',
    recipientsCount: 'recipientsCount',
    attachmentAttached: 'attachmentAttached',
    editable: 'editable',
    recipients: 'recipients',
} as const;
